import { render, staticRenderFns } from "./ReadyToPlay.vue?vue&type=template&id=9cd87a7c&scoped=true&"
import script from "./ReadyToPlay.vue?vue&type=script&lang=js&"
export * from "./ReadyToPlay.vue?vue&type=script&lang=js&"
import style0 from "./ReadyToPlay.vue?vue&type=style&index=0&id=9cd87a7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd87a7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
